import { render } from "./DeliverySettingsForm.vue?vue&type=template&id=07696126&scoped=true&ts=true"
import script from "./DeliverySettingsForm.vue?vue&type=script&lang=ts"
export * from "./DeliverySettingsForm.vue?vue&type=script&lang=ts"

import "./DeliverySettingsForm.vue?vue&type=style&index=0&id=07696126&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07696126"]])

export default __exports__